import React from 'react';
import { Link } from 'react-router-dom';
import { SOCIAL_LINKS, CONTACT_EMAIL, EXTERNAL_LINK_PROPS } from '../../config/externalLinks';
import { XIcon } from '../XIcon/XIcon';
import './CompactFooter.scss';

export const CompactFooter: React.FC = () => {
  return (
    <footer className="site-footer">
        <div className="footer-links-inline">
            <Link to="/about-us">About Us</Link>
            <span className="separator">|</span>
            <Link to="/our-team">Our Team</Link>
            <span className="separator">|</span>
            <Link to="/our-expertise">Our Expertise</Link>
            <span className="separator">|</span>
            <Link to="/faq">FAQs</Link>
            <span className="separator">|</span>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <span className="separator">|</span>
            <Link to="/contact-us">Contact Us</Link>
            <span className="separator">|</span>
            <Link to="/terms-use">Terms Of Use</Link>
            <span className="separator">|</span>
            <Link to="/disclaimer">Disclaimer</Link>
        </div>
        <div className="footer-divider"></div>
        <div className="footer-contact-row">
            <div className="contact-info">
                <i className="fa fa-envelope"></i> <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
            </div>
            <div className="social-links">
                <a href={SOCIAL_LINKS.facebook} {...EXTERNAL_LINK_PROPS} aria-label="Facebook"><i className="fa-brands fa-facebook-f"></i></a>
                <a href={SOCIAL_LINKS.instagram} {...EXTERNAL_LINK_PROPS} aria-label="Instagram"><i className="fa-brands fa-instagram"></i></a>
                <a href={SOCIAL_LINKS.linkedin} {...EXTERNAL_LINK_PROPS} aria-label="LinkedIn"><i className="fa-brands fa-linkedin-in"></i></a>
                <a href={SOCIAL_LINKS.x} {...EXTERNAL_LINK_PROPS} aria-label="X (formerly Twitter)"><XIcon /></a>
            </div>
        </div>
    </footer>
  );
};
